import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  const PRIMARY_MAIN = theme.palette.primary.main;

  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 250, // Adjust the width to accommodate both SVGs
        height: 50,
        display: 'flex',
        alignItems: 'center',
        gap: 0,
        ...sx,
      }}
      {...other}
    >
     
     <svg
      xmlns="http://www.w3.org/2000/svg"
    width="70.000000pt" height="70.000000pt" viewBox="0 0 1600.000000 1600.000000"
      style={{ marginTop: '60px' }}
      
    >
   <path fill="#09579A" opacity="1.000000" stroke="none" 
	d="
M579.000000,0.999996 
	C727.651245,1.000000 876.302490,1.000000 1024.976807,1.000000 
	C1024.976807,342.282501 1024.976807,683.565002 1024.976807,1024.923828 
	C683.752930,1024.923828 342.505768,1024.923828 1.129329,1024.923828 
	C1.129329,683.788330 1.129329,342.576599 1.129329,1.000000 
	C165.361191,1.000000 329.722656,1.000000 494.545532,1.468647 
	C495.008331,49.423969 495.014679,96.910645 494.993683,144.397308 
	C494.992828,146.382370 495.523132,149.094788 494.470398,150.232132 
	C488.447083,156.739395 482.019257,162.872253 475.472717,168.913025 
	C472.071198,165.317749 468.082794,164.554062 463.759399,165.217239 
	C459.154114,165.923630 454.600922,166.979599 449.989990,167.637405 
	C432.382202,170.149353 414.725586,174.718170 397.152924,174.435440 
	C377.694855,174.122360 358.214050,169.863586 338.912476,166.383881 
	C306.469849,160.535126 274.274902,153.920227 240.927231,154.824417 
	C207.343658,155.735001 175.469635,162.331482 145.750565,178.119980 
	C109.291397,197.489243 81.102104,224.955276 64.923935,263.458771 
	C53.425930,290.823639 49.914589,319.531586 52.009026,349.094452 
	C53.957882,376.602509 60.103230,402.870453 74.865791,426.416931 
	C94.382965,457.547150 121.002251,479.934814 156.804245,490.388336 
	C159.517014,491.180420 162.191269,492.104340 164.907547,493.438904 
	C164.941635,503.720703 164.989929,513.530762 164.953232,523.340515 
	C164.886078,541.291992 164.768707,559.243286 164.310577,577.156982 
	C162.395309,576.526184 160.829727,575.962524 159.290009,575.335388 
	C136.672333,566.123047 113.706268,564.327942 90.690720,573.316956 
	C54.933159,587.282532 31.157684,622.556091 30.209171,664.362732 
	C29.783768,683.112793 35.832546,700.199768 45.870613,715.679810 
	C49.154568,720.744080 54.526508,724.829224 59.701855,728.196899 
	C66.112160,732.368164 66.447098,731.840820 70.732628,725.298523 
	C71.462166,724.184753 72.264404,723.118591 73.262238,721.865723 
	C73.768524,721.440063 74.045624,721.179199 74.324844,720.848999 
	C74.326965,720.779724 74.389664,720.656006 74.504410,721.134033 
	C74.722969,723.605591 74.914391,725.598999 74.916954,727.592651 
	C74.941177,746.425720 74.899437,765.258850 74.951721,784.091736 
	C74.971710,791.290222 77.503273,794.558411 84.454338,796.051819 
	C87.511726,796.708618 90.719604,796.904541 93.859207,796.904968 
	C366.355316,796.941833 638.851440,796.939148 911.347534,796.938232 
	C912.847473,796.938232 914.351196,796.991943 915.846741,796.907349 
	C924.564209,796.414185 929.936462,790.876099 929.941467,782.138062 
	C929.972473,727.638855 929.980225,673.139587 929.934387,618.640381 
	C929.926147,608.845886 924.906799,604.025818 915.023071,604.017090 
	C892.023376,603.996704 869.023743,604.013672 846.024048,604.007996 
	C839.080505,604.006287 839.065125,603.994934 839.064209,597.192993 
	C839.059021,557.860229 839.050659,518.527405 839.073853,479.194641 
	C839.077148,473.532349 839.244934,467.870087 839.606445,462.185577 
	C840.239258,462.191010 840.602356,462.218658 841.293457,462.409424 
	C843.099121,462.673035 844.576599,462.773590 846.519226,462.853516 
	C848.816650,462.877991 850.649231,462.915222 852.481262,462.969269 
	C896.167603,464.258057 933.197266,451.267731 958.781250,413.563538 
	C966.530823,402.142670 973.004700,390.231995 974.587952,376.216766 
	C975.248169,370.372650 974.771545,364.949463 970.173035,360.524017 
	C967.928284,358.363739 966.506592,358.251404 964.019104,360.521484 
	C959.635498,364.521881 955.135681,368.826202 949.891968,371.368835 
	C936.097534,378.057739 920.999939,380.125580 906.029114,378.301025 
	C887.223755,376.009155 868.602539,372.083191 849.975952,368.479309 
	C828.413574,364.307434 806.654114,362.251160 784.858398,364.594940 
	C757.255859,367.563141 733.868103,380.225006 713.569885,398.870422 
	C712.463135,399.887054 711.197083,400.730225 708.966736,402.459045 
	C708.966736,398.907532 708.956970,396.780975 708.968140,394.654572 
	C709.245605,341.843262 709.535217,289.032013 709.797424,236.220627 
	C709.862366,223.150513 709.826599,222.912613 723.114441,223.164871 
	C744.918457,223.578812 766.759644,223.679413 788.504639,225.123337 
	C812.956848,226.747009 837.094299,230.763153 860.488098,238.607635 
	C890.458984,248.657562 916.390747,265.173126 938.566650,287.460754 
	C955.348938,304.327667 968.653076,323.900940 980.293396,344.610840 
	C981.119385,346.080322 982.163818,347.427002 983.106689,348.830780 
	C982.501831,333.697296 980.986450,318.997009 979.743835,304.273651 
	C977.686523,279.898407 975.756653,255.512146 973.864929,231.123398 
	C972.397400,212.203720 970.989502,193.278488 969.735229,174.343811 
	C969.412476,169.471252 967.712280,167.683624 962.446167,167.689529 
	C822.958008,167.845917 683.469666,167.812592 543.981323,167.827118 
	C542.267029,167.827301 540.552795,168.029099 538.594116,168.152115 
	C543.051086,177.461945 547.198914,186.125946 551.022217,194.679276 
	C549.325989,193.370926 547.841553,192.279190 546.600708,190.958618 
	C537.600891,181.380463 528.913818,171.491104 519.600464,162.230560 
	C512.200134,154.872238 507.796631,147.244797 508.743378,136.069122 
	C509.877747,122.678329 509.456360,122.878815 523.149902,124.340126 
	C539.089661,126.041153 553.955078,131.224121 568.938538,136.180313 
	C606.084900,148.467590 644.179688,154.485245 683.304443,154.008209 
	C691.206787,153.911865 692.974304,152.215607 692.976746,144.292160 
	C692.988098,107.973198 692.984802,71.654236 692.977417,35.335270 
	C692.975769,27.269108 690.759155,24.928656 682.547119,25.060568 
	C667.938171,25.295237 653.661926,23.258787 639.716858,19.036240 
	C626.808533,15.127625 614.018005,10.829957 601.108276,6.926287 
	C593.808899,4.719116 586.373901,2.960597 579.000000,0.999996 
M708.184570,971.824341 
	C643.423096,971.808533 578.661621,971.791443 513.900146,971.787598 
	C512.909424,971.787537 511.918640,971.949768 510.003571,971.941772 
	C447.081970,971.929504 384.160339,971.914978 321.238739,971.913025 
	C318.411346,971.912903 315.583923,972.027100 311.865692,971.901794 
	C311.368073,971.866272 310.870422,971.799744 310.372803,971.799683 
	C246.466873,971.790894 182.560959,971.784729 118.655029,971.797546 
	C117.374992,971.797791 116.095009,972.021484 114.569992,972.163757 
	C114.569992,977.541626 114.569992,982.651184 114.340324,988.697388 
	C114.340324,993.297729 114.340324,997.898071 114.340324,1002.523682 
	C379.009888,1002.523682 642.998962,1002.523682 907.149902,1002.523682 
	C907.149902,997.404602 907.149902,992.600708 907.316345,986.903870 
	C907.310425,984.074158 907.304932,981.244507 907.298645,978.414795 
	C907.283936,971.834595 907.283752,971.821228 900.856506,971.820862 
	C838.602966,971.817322 776.349426,971.817017 714.095886,971.827332 
	C712.436462,971.827576 710.777100,971.958618 708.184570,971.824341 
M296.926666,845.183899 
	C297.183960,846.653320 297.650024,848.120544 297.665771,849.592590 
	C297.801300,862.255188 297.913147,874.918701 297.919769,887.581909 
	C297.928497,904.245728 297.789398,920.909668 297.813385,937.573364 
	C297.820862,942.771301 295.981628,946.222107 290.451355,947.115051 
	C289.543060,947.261658 288.789673,948.367859 287.035706,949.776978 
	C300.840912,949.776978 313.171204,949.776978 325.501495,949.776978 
	C325.640167,949.372131 325.778839,948.967285 325.917511,948.562439 
	C324.806610,947.994202 323.753357,947.198608 322.574188,946.899658 
	C318.797577,945.942322 316.947266,943.639099 316.950500,939.744995 
	C316.963013,924.745789 316.862305,909.745361 317.072174,894.749146 
	C317.093933,893.194946 318.538452,891.045349 319.939484,890.224487 
	C329.867828,884.407471 339.225220,889.044128 339.789978,900.612366 
	C340.430908,913.740723 339.969391,926.923584 339.959717,940.082703 
	C339.957184,943.521057 338.179993,945.624634 334.939972,946.714233 
	C333.649414,947.148254 332.499023,947.999023 331.284821,948.660095 
	C331.431183,949.039307 331.577545,949.418579 331.723907,949.797791 
	C343.478210,949.797791 355.232544,949.797791 367.672516,949.797791 
	C366.894165,948.547607 366.582886,947.447876 366.104553,947.369690 
	C359.627747,946.310547 359.239258,941.487000 359.224304,936.442932 
	C359.195679,926.776794 359.360535,917.107239 359.146423,907.445679 
	C359.032715,902.313721 358.819214,897.078552 357.711273,892.099060 
	C356.101105,884.862610 351.367065,880.160278 343.902649,878.580017 
	C336.838776,877.084595 330.329407,878.537170 324.320587,882.395264 
	C322.021851,883.871155 319.826019,885.507324 317.026489,887.458435 
	C317.026489,868.706848 317.026489,850.672913 317.026489,832.726929 
	C307.467316,834.627380 298.233673,836.463135 288.002380,838.497192 
	C291.294189,840.769287 293.944763,842.598877 296.926666,845.183899 
M191.714798,927.731140 
	C191.678680,929.726746 191.805847,931.741150 191.579285,933.714905 
	C190.342606,944.488342 183.297043,950.496338 172.652649,948.401978 
	C167.227219,947.334473 161.449829,944.647034 157.396439,940.967773 
	C153.294510,937.244507 151.122131,931.394409 148.109299,926.473022 
	C147.378906,925.279968 146.667206,924.075562 145.946899,922.876343 
	C145.330963,923.058960 144.715027,923.241577 144.099106,923.424194 
	C144.775604,928.891907 145.266281,934.390442 146.167267,939.820923 
	C148.048950,951.162354 145.913208,948.438721 156.588623,950.944519 
	C168.461227,953.731262 180.337509,954.148865 191.872055,949.084290 
	C212.944885,939.831970 218.042465,913.933655 201.527740,897.966736 
	C196.329849,892.941162 189.832382,889.257324 183.916595,884.977600 
	C179.075699,881.475525 173.735016,878.499512 169.473572,874.398926 
	C162.686646,867.868408 162.346725,856.009155 167.960968,849.271240 
	C173.194534,842.990173 183.380646,842.250183 191.687408,847.475098 
	C197.199829,850.942444 200.238937,856.141846 202.385849,862.075073 
	C202.919479,863.549866 203.974731,864.835938 204.790222,866.208801 
	C205.326538,865.948425 205.862869,865.688049 206.399185,865.427734 
	C205.488098,857.744263 204.576996,850.060730 203.619308,841.984436 
	C196.704575,841.282043 190.117828,840.159363 183.513550,840.044373 
	C172.555344,839.853577 162.224686,842.226257 154.448761,850.762390 
	C143.407425,862.882996 144.279404,881.597900 157.014938,892.829041 
	C163.707306,898.730835 171.578445,903.296692 178.921860,908.459351 
	C185.411026,913.021301 190.318192,918.669800 191.714798,927.731140 
M377.520996,911.982483 
	C375.654938,933.840942 388.922485,950.029175 410.455994,952.167786 
	C430.905487,954.198669 447.767181,940.783203 450.027588,920.683960 
	C452.514160,898.574158 439.628296,880.657410 419.540253,878.293701 
	C398.379944,875.803772 380.394501,889.884705 377.520996,911.982483 
M466.983002,896.521973 
	C459.072937,911.873779 460.871307,930.072083 471.401428,941.233948 
	C484.559692,955.181702 509.089050,956.301758 523.069641,943.593323 
	C537.816040,930.188843 539.213562,904.764832 526.030823,889.723328 
	C510.281311,871.752930 481.525482,874.772705 466.983002,896.521973 
M620.540527,887.872192 
	C617.422302,887.872192 614.304077,887.872192 610.969971,887.872192 
	C610.969971,875.417786 610.969971,863.525024 610.969971,851.016113 
	C626.189148,851.016113 641.086060,851.016113 656.026855,851.016113 
	C656.026855,846.663452 656.026855,842.932983 656.026855,839.244690 
	C635.937378,839.244690 616.217041,839.244690 596.399475,839.244690 
	C596.399475,876.343140 596.399475,913.061829 596.399475,949.888550 
	C601.259583,949.888550 605.820007,949.888550 610.825073,949.888550 
	C610.825073,933.123474 610.825073,916.716248 610.825073,899.786133 
	C624.997620,899.786133 638.725159,899.786133 652.432678,899.786133 
	C652.432678,895.547668 652.432678,891.852112 652.432678,887.872192 
	C641.823914,887.872192 631.676025,887.872192 620.540527,887.872192 
M555.595947,836.194397 
	C551.685242,836.862549 547.774475,837.530701 543.377136,838.282043 
	C544.223389,839.519775 544.440430,840.202148 544.764099,840.257202 
	C552.485413,841.569763 552.863342,847.105530 552.830200,853.375183 
	C552.687866,880.342285 552.771545,907.310486 552.764343,934.278320 
	C552.763916,935.941589 552.730652,937.606812 552.644653,939.267639 
	C552.431274,943.383240 550.661133,946.174255 546.318787,947.027344 
	C545.186401,947.249817 544.195435,948.192078 543.139526,948.803833 
	C543.293762,949.114380 543.447998,949.424927 543.602234,949.735474 
	C555.859558,949.735474 568.116821,949.735474 580.374084,949.735474 
	C579.949524,948.158386 579.220398,947.229248 578.356506,947.080017 
	C573.416565,946.226440 571.945007,943.026184 571.956848,938.475647 
	C572.043091,905.350281 572.079895,872.224731 572.131470,839.099243 
	C572.134827,836.974304 572.131958,834.849304 572.131958,832.465820 
	C566.710388,833.707642 561.574524,834.884033 555.595947,836.194397 
M841.434998,946.076050 
	C849.210938,952.976257 858.261414,952.112732 867.386719,950.118835 
	C868.340088,949.910583 869.535828,948.060242 869.569580,946.940125 
	C869.651672,944.215576 869.116333,941.472351 868.819946,938.643677 
	C867.640747,938.699524 866.987244,938.691956 866.343323,938.766724 
	C853.881836,940.212769 850.132935,937.288513 849.804932,924.704468 
	C849.449341,911.063477 849.679199,897.406921 849.694519,883.757202 
	C849.695374,882.990662 850.067444,882.224487 850.372742,881.050659 
	C856.912170,881.050659 863.350830,881.050659 870.097290,881.050659 
	C870.097290,877.188904 870.097290,873.784790 870.097290,869.900208 
	C863.355652,869.900208 856.772217,869.900208 849.467896,869.900208 
	C849.467896,862.099365 849.467896,854.753723 849.467896,846.846863 
	C845.941650,847.773132 843.278442,848.722473 840.534607,849.134338 
	C836.524414,849.736328 834.888000,851.550110 835.282776,855.796204 
	C835.705200,860.338440 835.377991,864.950317 835.377991,870.103271 
	C830.700745,870.103271 826.819763,870.103271 823.223389,870.103271 
	C823.223389,874.098755 823.223389,877.492859 823.223389,881.429932 
	C827.380798,881.429932 831.123535,881.429932 835.377808,881.429932 
	C835.377808,883.783997 835.377747,885.577881 835.377808,887.371826 
	C835.378479,900.689514 835.328125,914.007507 835.401489,927.324768 
	C835.437805,933.918701 836.457825,940.281128 841.434998,946.076050 
M778.752014,896.604431 
	C773.356201,889.347900 775.923096,881.137268 784.783691,879.651794 
	C789.636414,878.838196 794.900330,880.205139 799.937012,880.894897 
	C801.958191,881.171631 803.867065,882.269531 806.117798,883.101135 
	C807.347412,879.368774 808.422424,876.105652 809.616333,872.481628 
	C797.677979,866.927856 785.908691,865.451355 774.178528,871.102295 
	C758.738525,878.540649 757.215088,898.379639 771.208313,908.216797 
	C774.695129,910.668030 778.880066,912.122314 782.731445,914.060120 
	C786.428772,915.920349 790.475830,917.331848 793.717773,919.797180 
	C799.575745,924.252075 799.668884,932.971863 793.819702,936.984741 
	C790.981445,938.931824 786.962891,940.431274 783.648682,940.147522 
	C776.704956,939.553101 769.873718,937.643494 762.545166,936.184143 
	C761.947754,937.839966 761.182617,940.381348 760.120300,942.791809 
	C758.959595,945.425537 759.848511,946.677734 762.383301,947.657104 
	C773.822388,952.076721 785.437195,952.985413 797.061707,948.889282 
	C805.306702,945.983948 810.844543,940.232605 812.062622,931.209534 
	C813.386719,921.401306 810.292969,913.399109 801.571594,908.204773 
	C798.020203,906.089661 794.106750,904.588440 790.390930,902.741699 
	C786.684448,900.899658 783.019104,898.974792 778.752014,896.604431 
M273.193909,879.098999 
	C257.553406,875.598206 245.039795,882.108337 234.265228,892.270264 
	C217.683273,907.909363 219.861526,936.003052 238.042511,947.426086 
	C253.476624,957.123169 274.349701,951.639465 283.053802,935.552368 
	C283.363983,934.979065 283.093201,934.091309 283.093201,932.330139 
	C281.170532,933.509827 279.846649,934.271118 278.574371,935.110657 
	C267.072113,942.700623 252.987885,939.777283 246.223602,927.805115 
	C239.791168,916.420227 239.795624,904.224060 244.072571,892.118591 
	C246.063034,886.484863 250.732758,883.866150 256.429016,885.628357 
	C261.525024,887.204834 266.538147,889.783752 270.853912,892.927734 
	C274.666290,895.705017 277.091980,895.143250 279.756531,892.026794 
	C282.901123,888.348694 282.787506,884.758972 279.241394,882.094421 
	C277.675323,880.917603 275.738129,880.234680 273.193909,879.098999 
M711.856873,946.362305 
	C712.510315,947.641663 713.069336,949.957581 713.833069,950.027222 
	C717.880249,950.396057 721.978882,950.200439 726.241028,950.200439 
	C726.241028,946.447510 726.221863,943.456116 726.244324,940.464905 
	C726.335754,928.302490 725.855164,916.100037 726.686890,903.987976 
	C727.735840,888.713745 735.325806,882.124756 750.452271,881.736023 
	C750.738831,881.728638 751.018921,881.466064 751.816467,881.061768 
	C751.816467,878.190979 751.681763,875.058655 751.854553,871.943359 
	C752.025330,868.864563 750.644714,867.814270 747.727905,867.799683 
	C739.329224,867.757690 733.072205,871.531860 728.410645,878.295349 
	C727.356018,879.825562 726.340515,881.382690 724.607971,883.972290 
	C724.348938,878.513245 724.154846,874.422180 723.955750,870.226196 
	C719.635071,870.226196 715.567200,870.226196 711.855408,870.226196 
	C711.855408,895.487183 711.855408,920.438171 711.856873,946.362305 
M687.802551,881.526001 
	C687.802551,877.756470 687.802551,873.986938 687.802551,870.139221 
	C682.698853,870.139221 678.261902,870.139221 673.605713,870.139221 
	C673.605713,896.878052 673.605713,923.381165 673.605713,949.843018 
	C678.522827,949.843018 683.056824,949.843018 687.802551,949.843018 
	C687.802551,927.124207 687.802551,904.820679 687.802551,881.526001 
M688.074280,853.473145 
	C688.570923,852.251831 689.334778,851.068420 689.514343,849.802063 
	C690.061218,845.943726 689.288025,842.388123 685.715454,840.222046 
	C682.115234,838.039368 678.381714,838.255859 674.950500,840.709045 
	C671.489685,843.183167 671.107300,846.863525 671.936890,850.577637 
	C673.409058,857.168213 681.046082,858.798462 688.074280,853.473145 
z"/>
<path fill="#3B67A5" opacity="1.000000" stroke="none" 
	d="
M475.728760,169.132233 
	C482.019257,162.872253 488.447083,156.739395 494.470398,150.232132 
	C495.523132,149.094788 494.992828,146.382370 494.993683,144.397308 
	C495.014679,96.910645 495.008331,49.423969 495.003479,1.468647 
	C522.687561,1.000000 550.375122,1.000000 578.531372,0.999996 
	C586.373901,2.960597 593.808899,4.719116 601.108276,6.926287 
	C614.018005,10.829957 626.808533,15.127625 639.716858,19.036240 
	C653.661926,23.258787 667.938171,25.295237 682.547119,25.060568 
	C690.759155,24.928656 692.975769,27.269108 692.977417,35.335270 
	C692.984802,71.654236 692.988098,107.973198 692.976746,144.292160 
	C692.974304,152.215607 691.206787,153.911865 683.304443,154.008209 
	C644.179688,154.485245 606.084900,148.467590 568.938538,136.180313 
	C553.955078,131.224121 539.089661,126.041153 523.149902,124.340126 
	C509.456360,122.878815 509.877747,122.678329 508.743378,136.069122 
	C507.796631,147.244797 512.200134,154.872238 519.600464,162.230560 
	C528.913818,171.491104 537.600891,181.380463 546.600708,190.958618 
	C547.841553,192.279190 549.325989,193.370926 551.252747,194.933258 
	C561.517700,216.563553 565.064697,239.104599 565.373901,262.106323 
	C561.550415,258.948090 558.093628,255.844315 554.471985,252.946655 
	C540.259888,241.575684 524.020752,235.867371 505.838867,234.865326 
	C488.808319,233.926712 473.316528,238.550903 458.513428,245.853516 
	C460.019379,242.289871 461.514374,239.140945 462.929657,235.956635 
	C472.387115,214.678009 477.537659,192.570572 475.728760,169.132233 
z"/>
<path fill="#3B67A4" opacity="1.000000" stroke="none" 
	d="
M839.336670,462.207825 
	C839.244934,467.870087 839.077148,473.532349 839.073853,479.194641 
	C839.050659,518.527405 839.059021,557.860229 839.064209,597.192993 
	C839.065125,603.994934 839.080505,604.006287 846.024048,604.007996 
	C869.023743,604.013672 892.023376,603.996704 915.023071,604.017090 
	C924.906799,604.025818 929.926147,608.845886 929.934387,618.640381 
	C929.980225,673.139587 929.972473,727.638855 929.941467,782.138062 
	C929.936462,790.876099 924.564209,796.414185 915.846741,796.907349 
	C914.351196,796.991943 912.847473,796.938232 911.347534,796.938232 
	C638.851440,796.939148 366.355316,796.941833 93.859207,796.904968 
	C90.719604,796.904541 87.511726,796.708618 84.454338,796.051819 
	C77.503273,794.558411 74.971710,791.290222 74.951721,784.091736 
	C74.899437,765.258850 74.941177,746.425720 74.916954,727.592651 
	C74.914391,725.598999 74.722969,723.605591 74.621811,720.794983 
	C83.146385,706.457458 94.956062,698.221375 111.183228,697.640137 
	C111.085831,714.888306 110.991882,731.687805 111.049355,748.486938 
	C111.077507,756.717712 116.235138,761.924194 124.411331,761.988037 
	C137.717651,762.091797 151.025787,762.078552 164.332367,761.993713 
	C172.253952,761.943298 177.715149,756.933533 177.841537,749.009033 
	C178.048325,736.043518 177.773163,723.070374 178.093903,710.119141 
	C190.134628,714.299133 201.782730,718.460266 213.319183,723.113708 
	C213.436340,733.051819 213.266083,742.530212 214.034058,751.932007 
	C214.547256,758.214417 219.246872,761.889465 225.672195,761.958923 
	C239.467636,762.107971 253.266708,762.107788 267.062378,761.972290 
	C274.451599,761.899719 279.311493,757.080444 279.878662,749.447205 
	C280.123749,746.148499 279.827972,742.809692 280.201599,739.446289 
	C293.004120,739.401794 305.382904,739.400085 317.510254,739.638550 
	C316.823914,742.909851 316.049652,745.937744 316.020020,748.972839 
	C315.942017,756.962402 321.027100,761.967834 329.074005,762.004456 
	C342.371155,762.065002 355.669067,762.065186 368.966187,761.999268 
	C376.415436,761.962341 381.786377,756.735168 381.950623,749.213196 
	C382.121124,741.404663 382.036652,733.588989 381.946960,725.777893 
	C381.932617,724.526123 381.307831,723.281433 381.220032,721.797241 
	C393.680939,714.064392 405.887085,706.567810 418.055542,699.532959 
	C417.995911,716.128662 417.906769,732.262878 417.979156,748.396301 
	C418.017731,756.995850 422.869019,761.961914 431.110046,762.000732 
	C444.416351,762.063416 457.723450,762.067200 471.029694,761.997131 
	C478.846222,761.956055 483.928558,757.101135 483.956879,749.239441 
	C484.064056,719.466309 483.981323,689.692505 484.021881,659.918945 
	C484.028625,654.956116 482.010254,650.778259 477.777008,648.784729 
	C474.523987,647.252808 470.434753,647.496582 466.832703,646.613647 
	C473.201996,633.247314 480.588043,620.628174 485.486938,607.107849 
	C497.729309,573.320312 499.121582,538.291016 492.956848,503.176758 
	C481.880768,440.087646 445.915131,397.691559 385.212860,376.586304 
	C383.026367,375.826080 380.911194,374.860657 378.833069,373.527832 
	C378.938507,367.584381 378.739716,362.089355 379.081848,356.628174 
	C379.361755,352.160950 377.608154,350.931305 373.322388,350.984497 
	C357.212952,351.184601 341.099426,351.040222 324.987610,351.082153 
	C321.567657,351.091064 318.083862,351.186798 316.533112,347.380585 
	C315.001404,343.621033 316.831482,340.701996 319.406189,338.018799 
	C325.264801,331.913452 331.185333,325.856506 336.792145,319.524323 
	C340.458496,315.383636 343.619385,310.795380 347.411499,306.394226 
	C351.125641,306.715088 354.433258,307.068115 357.744690,307.380524 
	C378.984314,309.384155 398.813232,305.523468 416.641571,293.259155 
	C417.982941,292.336426 419.535492,291.720673 421.002686,291.374084 
	C420.406158,294.543457 419.822388,297.306946 419.182983,300.057495 
	C416.276215,312.562073 415.954865,325.139160 418.721619,337.667389 
	C424.974945,365.983398 441.504395,386.260254 467.949432,397.856598 
	C493.809204,409.196259 519.567871,408.171478 544.106995,393.807129 
	C551.636230,389.399750 558.160461,383.275452 565.184753,378.408752 
	C565.200256,407.559845 565.176025,436.239594 564.669922,464.934753 
	C553.860291,464.961121 543.531555,464.888519 533.205078,465.011139 
	C525.765930,465.099487 520.124023,470.164459 520.089844,477.307709 
	C519.945618,507.457367 519.940613,537.608582 520.092346,567.758179 
	C520.128540,574.953979 525.784912,579.971741 533.089844,580.024475 
	C541.085083,580.082214 549.081116,580.046936 557.076782,580.039062 
	C564.047119,580.032227 564.064331,580.024170 564.065735,573.224121 
	C564.072388,541.241272 564.052124,509.258423 564.106995,477.275696 
	C564.110657,475.165710 564.661194,473.056671 565.000610,471.417603 
	C565.059082,528.838684 565.077820,585.789429 565.070740,642.740173 
	C565.070557,644.225891 564.788391,645.711609 564.205566,647.131958 
	C553.458557,647.035217 543.143372,646.947510 532.828735,646.991943 
	C525.863281,647.021973 520.148804,652.065979 520.109009,658.985291 
	C519.934814,689.266296 519.949646,719.549194 520.091797,749.830505 
	C520.123291,756.543701 525.692078,761.924866 532.168030,761.975464 
	C546.143494,762.084595 560.121216,762.096802 574.096375,761.971741 
	C580.597534,761.913574 585.865906,756.719543 585.987061,750.276550 
	C586.124573,742.962708 585.911255,735.642273 586.322266,728.242981 
	C598.609924,728.217102 610.425842,728.272888 622.178589,728.764893 
	C622.086304,735.513916 621.989624,741.827393 622.044373,748.139526 
	C622.120728,756.949768 627.153076,761.958923 636.034729,762.005371 
	C648.661743,762.071411 661.289368,762.043579 673.916626,762.017029 
	C683.282532,761.997375 688.655945,756.760498 688.899353,747.247864 
	C689.056580,741.104187 688.941406,734.953613 689.419556,728.776855 
	C703.276184,728.846069 716.661560,728.944580 729.714417,729.240540 
	C724.897705,729.564087 723.594727,731.993958 723.949585,736.222107 
	C724.282532,740.189331 723.920654,744.209412 724.052307,748.200012 
	C724.344543,757.056274 729.399292,761.965088 738.293030,762.005859 
	C750.776733,762.063049 763.260925,762.039124 775.744873,762.017700 
	C786.103760,761.999939 790.942932,757.177490 790.957581,746.685730 
	C790.997498,718.222351 790.994751,689.758789 790.956055,661.295410 
	C790.943542,652.086609 785.914246,647.020630 776.817078,646.983643 
	C764.333374,646.932800 751.849182,646.958557 739.365234,646.972717 
	C728.958069,646.984558 724.065674,651.782532 724.038025,662.199646 
	C723.993042,679.177551 724.052979,696.155762 723.808716,712.897522 
	C712.572021,696.592896 707.539124,679.017517 708.757690,659.416992 
	C709.685669,644.489441 709.670532,629.491882 709.730286,614.524048 
	C709.860657,581.899109 709.735657,549.273193 709.787659,516.647766 
	C709.811096,501.957153 710.743896,487.354736 715.645386,473.326080 
	C719.176880,463.218750 726.135803,456.509644 736.353638,453.293335 
	C748.861084,449.356354 761.629456,449.582611 774.370117,451.571014 
	C796.050964,454.954590 817.683716,458.645844 839.336670,462.207825 
M724.020203,562.377991 
	C724.020935,563.210999 724.010864,564.044189 724.023987,564.877014 
	C724.187744,575.287109 728.987427,580.032043 739.384277,580.038879 
	C751.879761,580.047119 764.375244,580.061646 776.870667,580.032227 
	C785.904785,580.010925 790.941772,574.957275 790.954590,565.753906 
	C790.994568,536.931091 790.993958,508.108154 790.955444,479.285339 
	C790.943359,470.217194 785.758301,465.032776 776.725403,464.991577 
	C764.729980,464.936859 752.734192,464.968658 740.738525,464.978424 
	C728.366089,464.988525 724.027954,469.383331 724.023254,481.938416 
	C724.013428,508.428802 724.020203,534.919189 724.020203,562.377991 
M887.864563,759.553284 
	C889.564209,756.246277 892.697510,752.957336 892.739502,749.629456 
	C893.119873,719.476685 893.049988,689.316528 892.890686,659.159790 
	C892.853943,652.196167 887.192078,647.030640 880.295715,646.995361 
	C866.800049,646.926270 853.303589,646.923096 839.807922,646.992065 
	C831.620789,647.033875 826.988098,651.534668 826.970642,659.621216 
	C826.906555,689.445618 826.915894,719.270264 826.962463,749.094727 
	C826.974609,756.878784 832.000305,761.949463 839.731018,761.994751 
	C853.226562,762.073730 866.724182,762.108887 880.217712,761.926208 
	C882.579468,761.894226 884.925415,760.705017 887.864563,759.553284 
z"/>
<path fill="#404140" opacity="1.000000" stroke="none" 
	d="
M111.249054,697.191284 
	C94.956062,698.221375 83.146385,706.457458 74.507065,720.316956 
	C74.389664,720.656006 74.326965,720.779724 74.048798,720.963989 
	C73.524788,721.442383 73.278931,721.736450 73.033066,722.030457 
	C72.264404,723.118591 71.462166,724.184753 70.732628,725.298523 
	C66.447098,731.840820 66.112160,732.368164 59.701855,728.196899 
	C54.526508,724.829224 49.154568,720.744080 45.870613,715.679810 
	C35.832546,700.199768 29.783768,683.112793 30.209171,664.362732 
	C31.157684,622.556091 54.933159,587.282532 90.690720,573.316956 
	C113.706268,564.327942 136.672333,566.123047 159.290009,575.335388 
	C160.829727,575.962524 162.395309,576.526184 164.554901,577.417725 
	C190.688049,590.129456 213.500092,606.618225 235.515793,624.347107 
	C245.197876,632.143921 255.186844,639.559631 265.207428,647.418701 
	C270.145447,651.544739 274.912506,655.400391 279.879395,659.528809 
	C290.958710,668.779480 302.942657,675.850830 316.526611,680.889893 
	C319.214752,681.866882 321.532135,682.850952 323.943970,683.462463 
	C346.400269,689.155518 365.581757,683.126465 382.234314,666.947021 
	C383.364929,665.963196 384.267334,665.208801 385.018616,664.325745 
	C398.997467,647.895264 403.805359,629.010193 399.710114,607.924500 
	C397.021973,594.083679 391.498566,581.580872 380.894073,571.401917 
	C363.494080,552.906494 341.631165,542.884155 317.817047,535.583069 
	C304.962708,531.919128 292.409424,528.454956 279.508484,524.879028 
	C257.248932,518.734802 235.337051,512.702454 213.126617,506.448242 
	C196.846527,501.806610 180.864975,497.386810 164.883423,492.967010 
	C162.191269,492.104340 159.517014,491.180420 156.804245,490.388336 
	C121.002251,479.934814 94.382965,457.547150 74.865791,426.416931 
	C60.103230,402.870453 53.957882,376.602509 52.009026,349.094452 
	C49.914589,319.531586 53.425930,290.823639 64.923935,263.458771 
	C81.102104,224.955276 109.291397,197.489243 145.750565,178.119980 
	C175.469635,162.331482 207.343658,155.735001 240.927231,154.824417 
	C274.274902,153.920227 306.469849,160.535126 338.912476,166.383881 
	C358.214050,169.863586 377.694855,174.122360 397.152924,174.435440 
	C414.725586,174.718170 432.382202,170.149353 449.989990,167.637405 
	C454.600922,166.979599 459.154114,165.923630 463.759399,165.217239 
	C468.082794,164.554062 472.071198,165.317749 475.472717,168.913025 
	C477.537659,192.570572 472.387115,214.678009 462.929657,235.956635 
	C461.514374,239.140945 460.019379,242.289871 458.316345,246.041458 
	C456.879181,248.409866 455.618591,250.150421 454.505493,251.980667 
	C445.752899,266.372192 435.031128,279.061676 421.757233,289.911682 
	C421.347412,290.382568 421.161438,290.691254 420.992767,290.995789 
	C421.010040,290.991638 420.989868,290.962219 420.989868,290.962219 
	C419.535492,291.720673 417.982941,292.336426 416.641571,293.259155 
	C398.813232,305.523468 378.984314,309.384155 357.744690,307.380524 
	C354.433258,307.068115 351.125641,306.715088 346.991577,306.284485 
	C339.902893,304.738495 333.457153,303.813324 327.415985,301.720367 
	C317.526825,298.294373 309.153748,292.543335 303.939209,282.587280 
	C303.659485,274.109924 303.352966,266.106384 303.005981,257.691345 
	C302.635468,255.309280 302.353882,253.329147 301.967865,251.369614 
	C298.323090,232.867630 289.064423,218.212860 271.096405,211.185425 
	C242.594864,200.038254 214.048431,200.850998 186.240402,214.008820 
	C176.138855,218.788513 167.552612,225.757263 162.116379,235.770432 
	C151.243988,255.796555 155.235703,282.006378 171.205978,298.790649 
	C187.369186,315.777649 207.800995,325.397217 229.708893,331.847626 
	C264.224304,342.010162 299.012390,351.244476 333.659485,360.962799 
	C348.726593,365.189026 363.730286,369.641266 378.762787,373.990875 
	C380.911194,374.860657 383.026367,375.826080 385.212860,376.586304 
	C445.915131,397.691559 481.880768,440.087646 492.956848,503.176758 
	C499.121582,538.291016 497.729309,573.320312 485.486938,607.107849 
	C480.588043,620.628174 473.201996,633.247314 466.608551,646.842285 
	C464.290161,650.291321 462.372711,653.219177 460.322296,656.050781 
	C448.405731,672.507385 433.668427,686.202026 418.093231,699.071167 
	C405.887085,706.567810 393.680939,714.064392 380.877411,721.892456 
	C360.311951,731.120605 339.613190,737.357605 317.761688,739.398376 
	C305.382904,739.400085 293.004120,739.401794 279.800720,739.328125 
	C271.798157,737.939331 264.498535,737.084045 257.467438,735.217407 
	C242.713791,731.300415 228.101303,726.851746 213.430847,722.621460 
	C201.782730,718.460266 190.134628,714.299133 177.774124,709.981689 
	C168.917084,707.445679 160.849823,704.745117 152.610352,702.758728 
	C139.037674,699.486511 125.425247,696.136780 111.249054,697.191284 
M459.417938,174.875137 
	C455.157379,175.653397 450.916351,176.566956 446.632751,177.185730 
	C430.833801,179.467926 414.967316,183.744308 399.226562,183.342148 
	C379.734589,182.844177 360.251282,178.960495 340.927490,175.600632 
	C307.634399,169.811890 274.625916,162.604721 240.451416,163.589523 
	C200.485062,164.741211 163.468582,174.567322 130.444824,197.670837 
	C100.131157,218.878357 78.232399,246.431656 67.463516,282.167603 
	C59.743675,307.785492 58.807137,333.983978 61.948910,360.374084 
	C67.051277,403.232697 85.662971,438.536804 121.627670,463.372437 
	C131.250839,470.017761 141.705872,476.588959 152.764969,479.833862 
	C208.365738,496.147858 264.366913,511.091217 320.072449,527.056763 
	C345.144348,534.242493 368.271423,545.440918 386.855743,564.543640 
	C411.337708,589.708496 418.153870,633.182434 396.753448,663.393555 
	C377.653412,690.357178 344.565704,701.288025 313.849609,689.329712 
	C297.582275,682.996521 283.109619,673.648743 269.426147,662.780273 
	C244.648300,643.099670 219.691895,623.625061 194.347748,604.682983 
	C178.654785,592.954102 161.228165,584.050537 142.156158,579.032776 
	C111.748886,571.032837 85.724953,579.679260 64.181389,601.670837 
	C42.428898,623.875671 27.820452,665.133240 49.924049,705.805054 
	C53.112343,711.671692 56.783253,717.111206 63.008778,720.215576 
	C66.078163,716.199158 68.742836,712.372009 71.751427,708.837585 
	C81.899681,696.915588 94.517860,689.065735 110.393333,688.510742 
	C119.466118,688.193542 128.706924,689.179443 137.696533,690.651001 
	C163.461548,694.868530 187.865280,703.925293 212.358749,712.599609 
	C234.687531,720.507385 257.240204,728.018127 280.846466,730.618347 
	C317.447479,734.650024 352.329163,727.603943 384.585632,709.923889 
	C424.580109,688.002686 455.632599,657.224548 473.590668,614.631592 
	C489.102417,577.840820 491.052460,539.464294 483.723755,500.776428 
	C472.808502,443.155640 438.843079,404.656219 383.573486,385.240814 
	C368.506592,379.948029 353.093353,375.593414 337.717346,371.237915 
	C300.703430,360.753082 263.490570,350.951202 226.607468,340.031128 
	C203.934021,333.318146 182.937164,323.162506 165.808960,305.923859 
	C141.465698,281.423676 135.525406,229.573395 181.580353,206.524963 
	C209.878632,192.362915 239.376511,191.883087 269.076355,200.905777 
	C287.695648,206.562241 300.447937,219.239304 307.224304,237.671722 
	C311.609741,249.600677 312.937836,261.999573 312.358826,274.559753 
	C312.104523,280.076416 314.162170,283.904388 318.369110,286.842255 
	C321.085938,288.739502 323.857788,290.963898 326.946411,291.845886 
	C335.866943,294.393158 344.853912,297.120728 354.006714,298.361267 
	C377.790009,301.584839 399.952362,297.278229 418.538239,281.040100 
	C444.318207,258.516602 460.179352,230.243744 465.941528,196.476715 
	C467.185822,189.185135 467.446686,181.725723 468.236298,173.559784 
	C464.782043,174.058517 462.523926,174.384552 459.417938,174.875137 
z"/>
<path fill="#404040" opacity="1.000000" stroke="none" 
	d="
M839.606445,462.185547 
	C817.683716,458.645844 796.050964,454.954590 774.370117,451.571014 
	C761.629456,449.582611 748.861084,449.356354 736.353638,453.293335 
	C726.135803,456.509644 719.176880,463.218750 715.645386,473.326080 
	C710.743896,487.354736 709.811096,501.957153 709.787659,516.647766 
	C709.735657,549.273193 709.860657,581.899109 709.730286,614.524048 
	C709.670532,629.491882 709.685669,644.489441 708.757690,659.416992 
	C707.539124,679.017517 712.572021,696.592896 723.916992,713.212036 
	C726.350830,717.526428 728.559143,721.222717 730.386475,725.098633 
	C730.872986,726.130737 730.191956,727.713257 730.046997,729.043091 
	C716.661560,728.944580 703.276184,728.846069 689.053223,728.621338 
	C666.224365,728.439575 644.233032,728.384094 622.241760,728.328674 
	C610.425842,728.272888 598.609924,728.217102 585.873901,728.166138 
	C567.869202,728.171021 550.784668,728.171021 533.700073,728.171021 
	C533.573730,727.616028 533.447388,727.060974 533.321045,726.505981 
	C543.013367,715.551941 548.925537,702.510254 553.314270,688.923462 
	C557.739136,675.224854 560.914795,661.122681 564.637695,647.197327 
	C564.788391,645.711609 565.070557,644.225891 565.070740,642.740173 
	C565.077820,585.789429 565.059082,528.838684 565.051331,471.069397 
	C565.089844,468.473694 565.120789,466.696503 565.151733,464.919342 
	C565.176025,436.239594 565.200256,407.559845 565.312561,378.025940 
	C565.555603,363.687134 565.828247,350.202545 565.840332,336.717743 
	C565.862671,311.897064 565.731873,287.076263 565.664917,262.255493 
	C565.064697,239.104599 561.517700,216.563553 551.577271,195.043945 
	C547.198914,186.125946 543.051086,177.461945 538.594116,168.152115 
	C540.552795,168.029099 542.267029,167.827301 543.981323,167.827118 
	C683.469666,167.812592 822.958008,167.845917 962.446167,167.689529 
	C967.712280,167.683624 969.412476,169.471252 969.735229,174.343811 
	C970.989502,193.278488 972.397400,212.203720 973.864929,231.123398 
	C975.756653,255.512146 977.686523,279.898407 979.743835,304.273651 
	C980.986450,318.997009 982.501831,333.697296 983.106689,348.830780 
	C982.163818,347.427002 981.119385,346.080322 980.293396,344.610840 
	C968.653076,323.900940 955.348938,304.327667 938.566650,287.460754 
	C916.390747,265.173126 890.458984,248.657562 860.488098,238.607635 
	C837.094299,230.763153 812.956848,226.747009 788.504639,225.123337 
	C766.759644,223.679413 744.918457,223.578812 723.114441,223.164871 
	C709.826599,222.912613 709.862366,223.150513 709.797424,236.220627 
	C709.535217,289.032013 709.245605,341.843262 708.968140,394.654572 
	C708.956970,396.780975 708.966736,398.907532 708.966736,402.459045 
	C711.197083,400.730225 712.463135,399.887054 713.569885,398.870422 
	C733.868103,380.225006 757.255859,367.563141 784.858398,364.594940 
	C806.654114,362.251160 828.413574,364.307434 849.975952,368.479309 
	C868.602539,372.083191 887.223755,376.009155 906.029114,378.301025 
	C920.999939,380.125580 936.097534,378.057739 949.891968,371.368835 
	C955.135681,368.826202 959.635498,364.521881 964.019104,360.521484 
	C966.506592,358.251404 967.928284,358.363739 970.173035,360.524017 
	C974.771545,364.949463 975.248169,370.372650 974.587952,376.216766 
	C973.004700,390.231995 966.530823,402.142670 958.781250,413.563538 
	C933.197266,451.267731 896.167603,464.258057 852.481262,462.969269 
	C850.649231,462.915222 848.816650,462.877991 846.200684,462.671051 
	C843.933105,462.421539 842.449280,462.333923 840.965393,462.246338 
	C840.602356,462.218658 840.239258,462.191010 839.606445,462.185547 
M730.008484,446.442719 
	C736.642212,444.953247 743.207397,442.814362 749.923523,442.105499 
	C765.341553,440.478149 780.498413,443.334412 795.545410,446.291962 
	C816.978088,450.504700 838.407227,454.334747 860.385437,454.288971 
	C905.800903,454.194397 939.408752,434.639923 960.042969,393.946625 
	C963.247009,387.627960 964.601440,380.371399 966.811279,373.548584 
	C966.259521,373.276337 965.707764,373.004089 965.156006,372.731842 
	C963.247192,373.948761 961.389893,375.256744 959.421631,376.368439 
	C939.983276,387.347931 918.971680,389.237793 897.414246,386.219604 
	C883.080688,384.212799 868.866455,381.267792 854.668640,378.397369 
	C832.527161,373.920898 810.241455,370.921661 787.657776,373.125031 
	C756.165283,376.197601 731.381714,392.256958 710.090515,414.622314 
	C707.545410,417.295868 705.054138,420.020660 701.464478,423.873962 
	C701.011292,413.287170 700.324341,404.343872 700.297791,395.398590 
	C700.178162,355.065979 700.172424,314.732574 700.278809,274.399872 
	C700.326660,256.242676 700.795410,238.086823 700.921021,219.929321 
	C700.944458,216.534851 702.094055,215.294861 705.535767,215.168060 
	C749.071716,213.563980 792.441589,213.940826 835.402222,222.796555 
	C885.477173,233.118790 926.730286,257.761078 959.058289,297.347595 
	C962.897034,302.048309 966.574402,306.880859 970.326538,311.652283 
	C970.612915,311.536957 970.899292,311.421600 971.185669,311.306244 
	C967.743469,266.458923 964.301208,221.611603 960.859985,176.777863 
	C824.850281,176.777863 689.202576,176.777863 553.157654,176.777863 
	C553.828308,178.256042 554.208069,179.169586 554.648499,180.052979 
	C566.720520,204.268723 573.633179,229.864578 574.006042,256.941101 
	C574.396057,285.263184 574.099365,313.594879 574.080872,341.922394 
	C574.031616,417.420135 573.986450,492.917938 573.905396,568.415649 
	C573.878906,593.077942 573.801636,617.740479 573.610229,642.401855 
	C573.578064,646.542480 573.147522,650.734863 572.381775,654.805725 
	C568.445557,675.730652 561.049316,695.500244 551.999573,714.697693 
	C551.398865,715.971924 550.875610,717.282593 549.942627,719.441040 
	C606.047119,719.441040 661.262573,719.441040 717.113037,719.441040 
	C714.916992,715.300598 713.124634,711.202454 710.714294,707.507446 
	C702.545532,694.985107 700.162598,681.035217 700.278687,666.478516 
	C700.382263,653.490784 700.956909,640.505737 700.993408,627.518555 
	C701.096313,590.852478 700.565063,554.177185 701.261292,517.523987 
	C701.534424,503.145081 703.621887,488.665649 706.326233,474.507660 
	C708.799011,461.561920 716.950073,452.112976 730.008484,446.442719 
z"/>
<path fill="#3B67A4" opacity="1.000000" stroke="none" 
	d="
M279.856110,524.990845 
	C292.409424,528.454956 304.962708,531.919128 317.445679,535.769409 
	C316.900757,537.821655 316.043518,539.481506 316.015961,541.155029 
	C315.876221,549.632446 315.918427,558.113464 315.961365,566.592896 
	C316.006958,575.596863 320.423340,580.000305 329.482697,580.030762 
	C342.285156,580.073792 355.092010,579.848755 367.888794,580.122437 
	C374.450439,580.262756 378.646881,577.546448 381.073425,571.657715 
	C391.498566,581.580872 397.021973,594.083679 399.710114,607.924500 
	C403.805359,629.010193 398.997467,647.895264 385.018616,664.325745 
	C384.267334,665.208801 383.364929,665.963196 382.251343,666.478516 
	C381.963989,663.688660 382.121918,661.184448 381.920288,658.709595 
	C381.411499,652.465027 376.275055,647.091125 370.412262,647.034241 
	C356.130829,646.895569 341.845947,646.878418 327.564941,647.036865 
	C320.884827,647.110901 316.197205,651.710510 316.036743,658.318970 
	C315.855621,665.781677 316.125793,673.255371 316.199707,680.724243 
	C302.942657,675.850830 290.958710,668.779480 279.942444,659.139343 
	C278.143616,650.040222 273.741638,646.663696 265.036469,647.148376 
	C255.186844,639.559631 245.197876,632.143921 235.515793,624.347107 
	C213.500092,606.618225 190.688049,590.129456 164.916595,577.455322 
	C164.768707,559.243286 164.886078,541.291992 164.953232,523.340515 
	C164.989929,513.530762 164.941635,503.720703 164.907547,493.438904 
	C180.864975,497.386810 196.846527,501.806610 213.013229,506.939514 
	C213.150894,526.975281 212.985413,546.298767 213.108704,565.620361 
	C213.165314,574.494507 218.308716,580.544861 228.184814,580.163391 
	C240.993454,579.668640 253.835724,580.077332 266.663208,580.025574 
	C274.465729,579.994080 279.863617,574.827209 279.928558,566.967957 
	C280.044128,552.976746 279.894714,538.983337 279.856110,524.990845 
z"/>
<path fill="#FBFCFD" opacity="1.000000" stroke="none" 
	d="
M907.149902,987.796875 
	C907.149902,992.600708 907.149902,997.404602 907.149902,1002.523682 
	C642.998962,1002.523682 379.009888,1002.523682 114.340324,1002.523682 
	C114.340324,997.898071 114.340324,993.297729 114.883568,988.236816 
	C178.753967,987.764099 242.081116,987.755676 305.408264,987.726379 
	C307.900391,987.725220 310.392456,987.524231 313.363831,987.487610 
	C378.375122,987.576782 442.907166,987.596497 507.439209,987.598755 
	C508.593384,987.598816 509.747559,987.390991 511.360046,987.409058 
	C512.815735,987.579651 513.813049,987.657837 514.810364,987.657898 
	C578.072388,987.663818 641.334473,987.665405 704.596497,987.650757 
	C706.087158,987.650391 707.577759,987.460999 709.515381,987.478027 
	C712.290222,987.642090 714.618103,987.727112 716.946045,987.728149 
	C780.347351,987.756287 843.748596,987.775879 907.149902,987.796875 
z"/>
<path fill="#F9FAFC" opacity="1.000000" stroke="none" 
	d="
M296.760986,844.806152 
	C293.944763,842.598877 291.294189,840.769287 288.002380,838.497192 
	C298.233673,836.463135 307.467316,834.627380 317.026489,832.726929 
	C317.026489,850.672913 317.026489,868.706848 317.026489,887.458435 
	C319.826019,885.507324 322.021851,883.871155 324.320587,882.395264 
	C330.329407,878.537170 336.838776,877.084595 343.902649,878.580017 
	C351.367065,880.160278 356.101105,884.862610 357.711273,892.099060 
	C358.819214,897.078552 359.032715,902.313721 359.146423,907.445679 
	C359.360535,917.107239 359.195679,926.776794 359.224304,936.442932 
	C359.239258,941.487000 359.627747,946.310547 366.104553,947.369690 
	C366.582886,947.447876 366.894165,948.547607 367.672516,949.797791 
	C355.232544,949.797791 343.478210,949.797791 331.723907,949.797791 
	C331.577545,949.418579 331.431183,949.039307 331.284821,948.660095 
	C332.499023,947.999023 333.649414,947.148254 334.939972,946.714233 
	C338.179993,945.624634 339.957184,943.521057 339.959717,940.082703 
	C339.969391,926.923584 340.430908,913.740723 339.789978,900.612366 
	C339.225220,889.044128 329.867828,884.407471 319.939484,890.224487 
	C318.538452,891.045349 317.093933,893.194946 317.072174,894.749146 
	C316.862305,909.745361 316.963013,924.745789 316.950500,939.744995 
	C316.947266,943.639099 318.797577,945.942322 322.574188,946.899658 
	C323.753357,947.198608 324.806610,947.994202 325.917511,948.562439 
	C325.778839,948.967285 325.640167,949.372131 325.501495,949.776978 
	C313.171204,949.776978 300.840912,949.776978 287.035706,949.776978 
	C288.789673,948.367859 289.543060,947.261658 290.451355,947.115051 
	C295.981628,946.222107 297.820862,942.771301 297.813385,937.573364 
	C297.789398,920.909668 297.928497,904.245728 297.919769,887.581909 
	C297.913147,874.918701 297.801300,862.255188 297.665771,849.592590 
	C297.650024,848.120544 297.183960,846.653320 296.760986,844.806152 
z"/>
<path fill="#F3909C" opacity="1.000000" stroke="none" 
	d="
M312.884552,987.416382 
	C310.392456,987.524231 307.900391,987.725220 305.408264,987.726379 
	C242.081116,987.755676 178.753967,987.764099 114.998398,987.768433 
	C114.569992,982.651184 114.569992,977.541626 114.569992,972.163757 
	C116.095009,972.021484 117.374992,971.797791 118.655029,971.797546 
	C182.560959,971.784729 246.466873,971.790894 310.372803,971.799683 
	C310.870422,971.799744 311.368073,971.866272 312.293823,972.455872 
	C312.776123,977.812073 312.830353,982.614258 312.884552,987.416382 
z"/>
<path fill="#41B2AA" opacity="1.000000" stroke="none" 
	d="
M313.363831,987.487610 
	C312.830353,982.614258 312.776123,977.812073 312.739227,972.549011 
	C315.583923,972.027100 318.411346,971.912903 321.238739,971.913025 
	C384.160339,971.914978 447.081970,971.929504 510.469360,972.450378 
	C510.923981,977.732727 510.912872,982.506470 510.901733,987.280151 
	C509.747559,987.390991 508.593384,987.598816 507.439209,987.598755 
	C442.907166,987.596497 378.375122,987.576782 313.363831,987.487610 
z"/>
<path fill="#FBCA4C" opacity="1.000000" stroke="none" 
	d="
M511.360077,987.409058 
	C510.912872,982.506470 510.923981,977.732727 510.931519,972.497559 
	C511.918640,971.949768 512.909424,971.787537 513.900146,971.787598 
	C578.661621,971.791443 643.423096,971.808533 708.645874,972.388855 
	C709.094238,977.755493 709.081360,982.557617 709.068420,987.359741 
	C707.577759,987.460999 706.087158,987.650391 704.596497,987.650757 
	C641.334473,987.665405 578.072388,987.663818 514.810364,987.657898 
	C513.813049,987.657837 512.815735,987.579651 511.360077,987.409058 
z"/>
<path fill="#A997B2" opacity="1.000000" stroke="none" 
	d="
M709.515381,987.478027 
	C709.081360,982.557617 709.094238,977.755493 709.112427,972.491028 
	C710.777100,971.958618 712.436462,971.827576 714.095886,971.827332 
	C776.349426,971.817017 838.602966,971.817322 900.856506,971.820862 
	C907.283752,971.821228 907.283936,971.834595 907.298645,978.414795 
	C907.304932,981.244507 907.310425,984.074158 907.233154,987.350342 
	C843.748596,987.775879 780.347351,987.756287 716.946045,987.728149 
	C714.618103,987.727112 712.290222,987.642090 709.515381,987.478027 
z"/>
<path fill="#F7F8FB" opacity="1.000000" stroke="none" 
	d="
M191.652252,927.279541 
	C190.318192,918.669800 185.411026,913.021301 178.921860,908.459351 
	C171.578445,903.296692 163.707306,898.730835 157.014938,892.829041 
	C144.279404,881.597900 143.407425,862.882996 154.448761,850.762390 
	C162.224686,842.226257 172.555344,839.853577 183.513550,840.044373 
	C190.117828,840.159363 196.704575,841.282043 203.619308,841.984436 
	C204.576996,850.060730 205.488098,857.744263 206.399185,865.427734 
	C205.862869,865.688049 205.326538,865.948425 204.790222,866.208801 
	C203.974731,864.835938 202.919479,863.549866 202.385849,862.075073 
	C200.238937,856.141846 197.199829,850.942444 191.687408,847.475098 
	C183.380646,842.250183 173.194534,842.990173 167.960968,849.271240 
	C162.346725,856.009155 162.686646,867.868408 169.473572,874.398926 
	C173.735016,878.499512 179.075699,881.475525 183.916595,884.977600 
	C189.832382,889.257324 196.329849,892.941162 201.527740,897.966736 
	C218.042465,913.933655 212.944885,939.831970 191.872055,949.084290 
	C180.337509,954.148865 168.461227,953.731262 156.588623,950.944519 
	C145.913208,948.438721 148.048950,951.162354 146.167267,939.820923 
	C145.266281,934.390442 144.775604,928.891907 144.099106,923.424194 
	C144.715027,923.241577 145.330963,923.058960 145.946899,922.876343 
	C146.667206,924.075562 147.378906,925.279968 148.109299,926.473022 
	C151.122131,931.394409 153.294510,937.244507 157.396439,940.967773 
	C161.449829,944.647034 167.227219,947.334473 172.652649,948.401978 
	C183.297043,950.496338 190.342606,944.488342 191.579285,933.714905 
	C191.805847,931.741150 191.678680,929.726746 191.652252,927.279541 
z"/>
<path fill="#F8F9FC" opacity="1.000000" stroke="none" 
	d="
M377.574463,911.544861 
	C380.394501,889.884705 398.379944,875.803772 419.540253,878.293701 
	C439.628296,880.657410 452.514160,898.574158 450.027588,920.683960 
	C447.767181,940.783203 430.905487,954.198669 410.455994,952.167786 
	C388.922485,950.029175 375.654938,933.840942 377.574463,911.544861 
M406.047485,942.298828 
	C408.860382,946.284912 412.113892,949.469116 417.582550,948.398865 
	C422.998962,947.338806 425.214874,943.179932 426.181183,938.493713 
	C427.349670,932.827271 428.332672,927.031189 428.487640,921.266846 
	C428.778717,910.434692 428.210999,899.597595 423.027954,889.682190 
	C420.659546,885.151306 417.084229,881.844482 411.616211,882.210815 
	C405.999878,882.587036 403.047699,886.588867 401.843079,891.536438 
	C397.684357,908.617371 397.909668,925.449585 406.047485,942.298828 
z"/>
<path fill="#F9FAFC" opacity="1.000000" stroke="none" 
	d="
M467.163818,896.204102 
	C481.525482,874.772705 510.281311,871.752930 526.030823,889.723328 
	C539.213562,904.764832 537.816040,930.188843 523.069641,943.593323 
	C509.089050,956.301758 484.559692,955.181702 471.401428,941.233948 
	C460.871307,930.072083 459.072937,911.873779 467.163818,896.204102 
M512.751160,929.959473 
	C512.830872,923.484375 513.259277,916.990051 512.902527,910.539124 
	C512.451477,902.382507 511.302338,894.205383 506.190887,887.415222 
	C500.128510,879.361877 490.946777,880.602356 487.056335,889.848511 
	C486.287445,891.675781 485.608856,893.600830 485.286591,895.546692 
	C483.197876,908.157166 483.167389,920.779785 486.814545,933.083679 
	C488.096558,937.408691 490.405426,941.761963 493.314728,945.196533 
	C498.069885,950.810242 505.657471,949.761780 508.949554,943.169800 
	C510.835602,939.393250 511.439301,934.976318 512.751160,929.959473 
z"/>
<path fill="#F6F8FB" opacity="1.000000" stroke="none" 
	d="
M621.034302,887.872192 
	C631.676025,887.872192 641.823914,887.872192 652.432678,887.872192 
	C652.432678,891.852112 652.432678,895.547668 652.432678,899.786133 
	C638.725159,899.786133 624.997620,899.786133 610.825073,899.786133 
	C610.825073,916.716248 610.825073,933.123474 610.825073,949.888550 
	C605.820007,949.888550 601.259583,949.888550 596.399475,949.888550 
	C596.399475,913.061829 596.399475,876.343140 596.399475,839.244690 
	C616.217041,839.244690 635.937378,839.244690 656.026855,839.244690 
	C656.026855,842.932983 656.026855,846.663452 656.026855,851.016113 
	C641.086060,851.016113 626.189148,851.016113 610.969971,851.016113 
	C610.969971,863.525024 610.969971,875.417786 610.969971,887.872192 
	C614.304077,887.872192 617.422302,887.872192 621.034302,887.872192 
z"/>
<path fill="#FDFDFE" opacity="1.000000" stroke="none" 
	d="
M556.017273,836.127441 
	C561.574524,834.884033 566.710388,833.707642 572.131958,832.465820 
	C572.131958,834.849304 572.134827,836.974304 572.131470,839.099243 
	C572.079895,872.224731 572.043091,905.350281 571.956848,938.475647 
	C571.945007,943.026184 573.416565,946.226440 578.356506,947.080017 
	C579.220398,947.229248 579.949524,948.158386 580.374084,949.735474 
	C568.116821,949.735474 555.859558,949.735474 543.602234,949.735474 
	C543.447998,949.424927 543.293762,949.114380 543.139526,948.803833 
	C544.195435,948.192078 545.186401,947.249817 546.318787,947.027344 
	C550.661133,946.174255 552.431274,943.383240 552.644653,939.267639 
	C552.730652,937.606812 552.763916,935.941589 552.764343,934.278320 
	C552.771545,907.310486 552.687866,880.342285 552.830200,853.375183 
	C552.863342,847.105530 552.485413,841.569763 544.764099,840.257202 
	C544.440430,840.202148 544.223389,839.519775 543.377136,838.282043 
	C547.774475,837.530701 551.685242,836.862549 556.017273,836.127441 
z"/>
<path fill="#F5F7FA" opacity="1.000000" stroke="none" 
	d="
M841.185547,945.817505 
	C836.457825,940.281128 835.437805,933.918701 835.401489,927.324768 
	C835.328125,914.007507 835.378479,900.689514 835.377808,887.371826 
	C835.377747,885.577881 835.377808,883.783997 835.377808,881.429932 
	C831.123535,881.429932 827.380798,881.429932 823.223389,881.429932 
	C823.223389,877.492859 823.223389,874.098755 823.223389,870.103271 
	C826.819763,870.103271 830.700745,870.103271 835.377991,870.103271 
	C835.377991,864.950317 835.705200,860.338440 835.282776,855.796204 
	C834.888000,851.550110 836.524414,849.736328 840.534607,849.134338 
	C843.278442,848.722473 845.941650,847.773132 849.467896,846.846863 
	C849.467896,854.753723 849.467896,862.099365 849.467896,869.900208 
	C856.772217,869.900208 863.355652,869.900208 870.097290,869.900208 
	C870.097290,873.784790 870.097290,877.188904 870.097290,881.050659 
	C863.350830,881.050659 856.912170,881.050659 850.372742,881.050659 
	C850.067444,882.224487 849.695374,882.990662 849.694519,883.757202 
	C849.679199,897.406921 849.449341,911.063477 849.804932,924.704468 
	C850.132935,937.288513 853.881836,940.212769 866.343323,938.766724 
	C866.987244,938.691956 867.640747,938.699524 868.819946,938.643677 
	C869.116333,941.472351 869.651672,944.215576 869.569580,946.940125 
	C869.535828,948.060242 868.340088,949.910583 867.386719,950.118835 
	C858.261414,952.112732 849.210938,952.976257 841.185547,945.817505 
z"/>
<path fill="#F7F9FB" opacity="1.000000" stroke="none" 
	d="
M779.043884,896.845337 
	C783.019104,898.974792 786.684448,900.899658 790.390930,902.741699 
	C794.106750,904.588440 798.020203,906.089661 801.571594,908.204773 
	C810.292969,913.399109 813.386719,921.401306 812.062622,931.209534 
	C810.844543,940.232605 805.306702,945.983948 797.061707,948.889282 
	C785.437195,952.985413 773.822388,952.076721 762.383301,947.657104 
	C759.848511,946.677734 758.959595,945.425537 760.120300,942.791809 
	C761.182617,940.381348 761.947754,937.839966 762.545166,936.184143 
	C769.873718,937.643494 776.704956,939.553101 783.648682,940.147522 
	C786.962891,940.431274 790.981445,938.931824 793.819702,936.984741 
	C799.668884,932.971863 799.575745,924.252075 793.717773,919.797180 
	C790.475830,917.331848 786.428772,915.920349 782.731445,914.060120 
	C778.880066,912.122314 774.695129,910.668030 771.208313,908.216797 
	C757.215088,898.379639 758.738525,878.540649 774.178528,871.102295 
	C785.908691,865.451355 797.677979,866.927856 809.616333,872.481628 
	C808.422424,876.105652 807.347412,879.368774 806.117798,883.101135 
	C803.867065,882.269531 801.958191,881.171631 799.937012,880.894897 
	C794.900330,880.205139 789.636414,878.838196 784.783691,879.651794 
	C775.923096,881.137268 773.356201,889.347900 779.043884,896.845337 
z"/>
<path fill="#F7F8FB" opacity="1.000000" stroke="none" 
	d="
M273.581665,879.213257 
	C275.738129,880.234680 277.675323,880.917603 279.241394,882.094421 
	C282.787506,884.758972 282.901123,888.348694 279.756531,892.026794 
	C277.091980,895.143250 274.666290,895.705017 270.853912,892.927734 
	C266.538147,889.783752 261.525024,887.204834 256.429016,885.628357 
	C250.732758,883.866150 246.063034,886.484863 244.072571,892.118591 
	C239.795624,904.224060 239.791168,916.420227 246.223602,927.805115 
	C252.987885,939.777283 267.072113,942.700623 278.574371,935.110657 
	C279.846649,934.271118 281.170532,933.509827 283.093201,932.330139 
	C283.093201,934.091309 283.363983,934.979065 283.053802,935.552368 
	C274.349701,951.639465 253.476624,957.123169 238.042511,947.426086 
	C219.861526,936.003052 217.683273,907.909363 234.265228,892.270264 
	C245.039795,882.108337 257.553406,875.598206 273.581665,879.213257 
z"/>
<path fill="#F9FAFC" opacity="1.000000" stroke="none" 
	d="
M711.856140,945.875732 
	C711.855408,920.438171 711.855408,895.487183 711.855408,870.226196 
	C715.567200,870.226196 719.635071,870.226196 723.955750,870.226196 
	C724.154846,874.422180 724.348938,878.513245 724.607971,883.972290 
	C726.340515,881.382690 727.356018,879.825562 728.410645,878.295349 
	C733.072205,871.531860 739.329224,867.757690 747.727905,867.799683 
	C750.644714,867.814270 752.025330,868.864563 751.854553,871.943359 
	C751.681763,875.058655 751.816467,878.190979 751.816467,881.061768 
	C751.018921,881.466064 750.738831,881.728638 750.452271,881.736023 
	C735.325806,882.124756 727.735840,888.713745 726.686890,903.987976 
	C725.855164,916.100037 726.335754,928.302490 726.244324,940.464905 
	C726.221863,943.456116 726.241028,946.447510 726.241028,950.200439 
	C721.978882,950.200439 717.880249,950.396057 713.833069,950.027222 
	C713.069336,949.957581 712.510315,947.641663 711.856140,945.875732 
z"/>
<path fill="#F4F6FA" opacity="1.000000" stroke="none" 
	d="
M687.802551,882.021606 
	C687.802551,904.820679 687.802551,927.124207 687.802551,949.843018 
	C683.056824,949.843018 678.522827,949.843018 673.605713,949.843018 
	C673.605713,923.381165 673.605713,896.878052 673.605713,870.139221 
	C678.261902,870.139221 682.698853,870.139221 687.802551,870.139221 
	C687.802551,873.986938 687.802551,877.756470 687.802551,882.021606 
z"/>
<path fill="#F6F7FB" opacity="1.000000" stroke="none" 
	d="
M687.828613,853.768555 
	C681.046082,858.798462 673.409058,857.168213 671.936890,850.577637 
	C671.107300,846.863525 671.489685,843.183167 674.950500,840.709045 
	C678.381714,838.255859 682.115234,838.039368 685.715454,840.222046 
	C689.288025,842.388123 690.061218,845.943726 689.514343,849.802063 
	C689.334778,851.068420 688.570923,852.251831 687.828613,853.768555 
z"/>
<path fill="#3B67A4" opacity="1.000000" stroke="none" 
	d="
M841.293457,462.409424 
	C842.449280,462.333923 843.933105,462.421539 845.735596,462.691650 
	C844.576599,462.773590 843.099121,462.673035 841.293457,462.409424 
z"/>
<path fill="#3B67A4" opacity="1.000000" stroke="none" 
	d="
M73.262253,721.865723 
	C73.278931,721.736450 73.524788,721.442383 74.046677,721.033325 
	C74.045624,721.179199 73.768524,721.440063 73.262253,721.865723 
z"/>
<path fill="#09579A" opacity="1.000000" stroke="none" 
	d="
M565.373901,262.106323 
	C565.731873,287.076263 565.862671,311.897064 565.840332,336.717743 
	C565.828247,350.202545 565.555603,363.687134 565.272766,377.554626 
	C558.160461,383.275452 551.636230,389.399750 544.106995,393.807129 
	C519.567871,408.171478 493.809204,409.196259 467.949432,397.856598 
	C441.504395,386.260254 424.974945,365.983398 418.721619,337.667389 
	C415.954865,325.139160 416.276215,312.562073 419.182983,300.057495 
	C419.822388,297.306946 420.406158,294.543457 421.002686,291.374084 
	C420.989868,290.962219 421.010040,290.991638 421.216034,290.838623 
	C421.608398,290.373566 421.794769,290.061523 421.981140,289.749451 
	C435.031128,279.061676 445.752899,266.372192 454.505493,251.980667 
	C455.618591,250.150421 456.879181,248.409866 458.268494,246.439804 
	C473.316528,238.550903 488.808319,233.926712 505.838867,234.865326 
	C524.020752,235.867371 540.259888,241.575684 554.471985,252.946655 
	C558.093628,255.844315 561.550415,258.948090 565.373901,262.106323 
M495.008057,298.500000 
	C495.012817,306.822357 494.926025,315.146179 495.055481,323.466583 
	C495.137665,328.748657 497.708130,331.885529 502.220154,331.923370 
	C517.199158,332.049011 532.180176,332.008789 547.159851,331.926849 
	C550.990356,331.905914 553.420898,329.886444 553.898682,325.944458 
	C554.489258,321.071686 551.637573,318.086121 546.047119,318.032745 
	C535.395386,317.930969 524.739380,317.861053 514.090698,318.063965 
	C510.104279,318.139923 508.709991,316.652435 508.969910,312.806213 
	C509.193848,309.492432 509.014801,306.151428 509.014343,302.822479 
	C509.012177,287.675720 509.055756,272.528748 508.986267,257.382294 
	C508.957550,251.119598 506.469879,248.555023 501.180756,248.971237 
	C496.129822,249.368698 495.048767,252.890915 495.033142,257.053223 
	C494.982574,270.535309 495.010437,284.017731 495.008057,298.500000 
z"/>
<path fill="#09579A" opacity="1.000000" stroke="none" 
	d="
M303.912415,283.061035 
	C309.153748,292.543335 317.526825,298.294373 327.415985,301.720367 
	C333.457153,303.813324 339.902893,304.738495 346.586823,306.297882 
	C343.619385,310.795380 340.458496,315.383636 336.792145,319.524323 
	C331.185333,325.856506 325.264801,331.913452 319.406189,338.018799 
	C316.831482,340.701996 315.001404,343.621033 316.533112,347.380585 
	C318.083862,351.186798 321.567657,351.091064 324.987610,351.082153 
	C341.099426,351.040222 357.212952,351.184601 373.322388,350.984497 
	C377.608154,350.931305 379.361755,352.160950 379.081848,356.628174 
	C378.739716,362.089355 378.938507,367.584381 378.833069,373.527832 
	C363.730286,369.641266 348.726593,365.189026 333.659485,360.962799 
	C299.012390,351.244476 264.224304,342.010162 229.708893,331.847626 
	C207.800995,325.397217 187.369186,315.777649 171.205978,298.790649 
	C155.235703,282.006378 151.243988,255.796555 162.116379,235.770432 
	C167.552612,225.757263 176.138855,218.788513 186.240402,214.008820 
	C214.048431,200.850998 242.594864,200.038254 271.096405,211.185425 
	C289.064423,218.212860 298.323090,232.867630 301.967865,251.369614 
	C302.353882,253.329147 302.635468,255.309280 302.974884,258.147583 
	C303.293671,267.030548 303.603058,275.045776 303.912415,283.061035 
z"/>
<path fill="#08579A" opacity="1.000000" stroke="none" 
	d="
M724.020203,561.893799 
	C724.020203,534.919189 724.013428,508.428802 724.023254,481.938416 
	C724.027954,469.383331 728.366089,464.988525 740.738525,464.978424 
	C752.734192,464.968658 764.729980,464.936859 776.725403,464.991577 
	C785.758301,465.032776 790.943359,470.217194 790.955444,479.285339 
	C790.993958,508.108154 790.994568,536.931091 790.954590,565.753906 
	C790.941772,574.957275 785.904785,580.010925 776.870667,580.032227 
	C764.375244,580.061646 751.879761,580.047119 739.384277,580.038879 
	C728.987427,580.032043 724.187744,575.287109 724.023987,564.877014 
	C724.010864,564.044189 724.020935,563.210999 724.020203,561.893799 
z"/>
<path fill="#09579A" opacity="1.000000" stroke="none" 
	d="
M729.714417,729.240540 
	C730.191956,727.713257 730.872986,726.130737 730.386475,725.098633 
	C728.559143,721.222717 726.350830,717.526428 724.177002,713.448364 
	C724.052979,696.155762 723.993042,679.177551 724.038025,662.199646 
	C724.065674,651.782532 728.958069,646.984558 739.365234,646.972717 
	C751.849182,646.958557 764.333374,646.932800 776.817078,646.983643 
	C785.914246,647.020630 790.943542,652.086609 790.956055,661.295410 
	C790.994751,689.758789 790.997498,718.222351 790.957581,746.685730 
	C790.942932,757.177490 786.103760,761.999939 775.744873,762.017700 
	C763.260925,762.039124 750.776733,762.063049 738.293030,762.005859 
	C729.399292,761.965088 724.344543,757.056274 724.052307,748.200012 
	C723.920654,744.209412 724.282532,740.189331 723.949585,736.222107 
	C723.594727,731.993958 724.897705,729.564087 729.714417,729.240540 
z"/>
<path fill="#08579A" opacity="1.000000" stroke="none" 
	d="
M887.571655,759.801758 
	C884.925415,760.705017 882.579468,761.894226 880.217712,761.926208 
	C866.724182,762.108887 853.226562,762.073730 839.731018,761.994751 
	C832.000305,761.949463 826.974609,756.878784 826.962463,749.094727 
	C826.915894,719.270264 826.906555,689.445618 826.970642,659.621216 
	C826.988098,651.534668 831.620789,647.033875 839.807922,646.992065 
	C853.303589,646.923096 866.800049,646.926270 880.295715,646.995361 
	C887.192078,647.030640 892.853943,652.196167 892.890686,659.159790 
	C893.049988,689.316528 893.119873,719.476685 892.739502,749.629456 
	C892.697510,752.957336 889.564209,756.246277 887.571655,759.801758 
z"/>
<path fill="#08579A" opacity="1.000000" stroke="none" 
	d="
M418.055542,699.532959 
	C433.668427,686.202026 448.405731,672.507385 460.322296,656.050781 
	C462.372711,653.219177 464.290161,650.291321 466.493225,647.179321 
	C470.434753,647.496582 474.523987,647.252808 477.777008,648.784729 
	C482.010254,650.778259 484.028625,654.956116 484.021881,659.918945 
	C483.981323,689.692505 484.064056,719.466309 483.956879,749.239441 
	C483.928558,757.101135 478.846222,761.956055 471.029694,761.997131 
	C457.723450,762.067200 444.416351,762.063416 431.110046,762.000732 
	C422.869019,761.961914 418.017731,756.995850 417.979156,748.396301 
	C417.906769,732.262878 417.995911,716.128662 418.055542,699.532959 
z"/>
<path fill="#08579A" opacity="1.000000" stroke="none" 
	d="
M564.669922,464.934753 
	C565.120789,466.696503 565.089844,468.473694 565.008179,470.599030 
	C564.661194,473.056671 564.110657,475.165710 564.106995,477.275696 
	C564.052124,509.258423 564.072388,541.241272 564.065735,573.224121 
	C564.064331,580.024170 564.047119,580.032227 557.076782,580.039062 
	C549.081116,580.046936 541.085083,580.082214 533.089844,580.024475 
	C525.784912,579.971741 520.128540,574.953979 520.092346,567.758179 
	C519.940613,537.608582 519.945618,507.457367 520.089844,477.307709 
	C520.124023,470.164459 525.765930,465.099487 533.205078,465.011139 
	C543.531555,464.888519 553.860291,464.961121 564.669922,464.934753 
z"/>
<path fill="#09579A" opacity="1.000000" stroke="none" 
	d="
M564.205627,647.131958 
	C560.914795,661.122681 557.739136,675.224854 553.314270,688.923462 
	C548.925537,702.510254 543.013367,715.551941 533.321045,726.505981 
	C533.447388,727.060974 533.573730,727.616028 533.700073,728.171021 
	C550.784668,728.171021 567.869202,728.171021 585.402100,728.247864 
	C585.911255,735.642273 586.124573,742.962708 585.987061,750.276550 
	C585.865906,756.719543 580.597534,761.913574 574.096375,761.971741 
	C560.121216,762.096802 546.143494,762.084595 532.168030,761.975464 
	C525.692078,761.924866 520.123291,756.543701 520.091797,749.830505 
	C519.949646,719.549194 519.934814,689.266296 520.109009,658.985291 
	C520.148804,652.065979 525.863281,647.021973 532.828735,646.991943 
	C543.143372,646.947510 553.458557,647.035217 564.205627,647.131958 
z"/>
<path fill="#09579A" opacity="1.000000" stroke="none" 
	d="
M111.183228,697.640137 
	C125.425247,696.136780 139.037674,699.486511 152.610352,702.758728 
	C160.849823,704.745117 168.917084,707.445679 177.381500,709.962891 
	C177.773163,723.070374 178.048325,736.043518 177.841537,749.009033 
	C177.715149,756.933533 172.253952,761.943298 164.332367,761.993713 
	C151.025787,762.078552 137.717651,762.091797 124.411331,761.988037 
	C116.235138,761.924194 111.077507,756.717712 111.049355,748.486938 
	C110.991882,731.687805 111.085831,714.888306 111.183228,697.640137 
z"/>
<path fill="#0A5799" opacity="1.000000" stroke="none" 
	d="
M622.178589,728.764893 
	C644.233032,728.384094 666.224365,728.439575 688.581970,728.650574 
	C688.941406,734.953613 689.056580,741.104187 688.899353,747.247864 
	C688.655945,756.760498 683.282532,761.997375 673.916626,762.017029 
	C661.289368,762.043579 648.661743,762.071411 636.034729,762.005371 
	C627.153076,761.958923 622.120728,756.949768 622.044373,748.139526 
	C621.989624,741.827393 622.086304,735.513916 622.178589,728.764893 
z"/>
<path fill="#0A579A" opacity="1.000000" stroke="none" 
	d="
M213.319183,723.113647 
	C228.101303,726.851746 242.713791,731.300415 257.467438,735.217407 
	C264.498535,737.084045 271.798157,737.939331 279.377014,739.370850 
	C279.827972,742.809692 280.123749,746.148499 279.878662,749.447205 
	C279.311493,757.080444 274.451599,761.899719 267.062378,761.972290 
	C253.266708,762.107788 239.467636,762.107971 225.672195,761.958923 
	C219.246872,761.889465 214.547256,758.214417 214.034058,751.932007 
	C213.266083,742.530212 213.436340,733.051819 213.319183,723.113647 
z"/>
<path fill="#0A579A" opacity="1.000000" stroke="none" 
	d="
M317.510254,739.638550 
	C339.613190,737.357605 360.311951,731.120605 380.622620,722.128662 
	C381.307831,723.281433 381.932617,724.526123 381.946960,725.777893 
	C382.036652,733.588989 382.121124,741.404663 381.950623,749.213196 
	C381.786377,756.735168 376.415436,761.962341 368.966187,761.999268 
	C355.669067,762.065186 342.371155,762.065002 329.074005,762.004456 
	C321.027100,761.967834 315.942017,756.962402 316.020020,748.972839 
	C316.049652,745.937744 316.823914,742.909851 317.510254,739.638550 
z"/>
<path fill="#FEF101" opacity="1.000000" stroke="none" 
	d="
M459.841888,174.792862 
	C462.523926,174.384552 464.782043,174.058517 468.236298,173.559784 
	C467.446686,181.725723 467.185822,189.185135 465.941528,196.476715 
	C460.179352,230.243744 444.318207,258.516602 418.538239,281.040100 
	C399.952362,297.278229 377.790009,301.584839 354.006714,298.361267 
	C344.853912,297.120728 335.866943,294.393158 326.946411,291.845886 
	C323.857788,290.963898 321.085938,288.739502 318.369110,286.842255 
	C314.162170,283.904388 312.104523,280.076416 312.358826,274.559753 
	C312.937836,261.999573 311.609741,249.600677 307.224304,237.671722 
	C300.447937,219.239304 287.695648,206.562241 269.076355,200.905777 
	C239.376511,191.883087 209.878632,192.362915 181.580353,206.524963 
	C135.525406,229.573395 141.465698,281.423676 165.808960,305.923859 
	C182.937164,323.162506 203.934021,333.318146 226.607468,340.031128 
	C263.490570,350.951202 300.703430,360.753082 337.717346,371.237915 
	C353.093353,375.593414 368.506592,379.948029 383.573486,385.240814 
	C438.843079,404.656219 472.808502,443.155640 483.723755,500.776428 
	C491.052460,539.464294 489.102417,577.840820 473.590668,614.631592 
	C455.632599,657.224548 424.580109,688.002686 384.585632,709.923889 
	C352.329163,727.603943 317.447479,734.650024 280.846466,730.618347 
	C257.240204,728.018127 234.687531,720.507385 212.358749,712.599609 
	C187.865280,703.925293 163.461548,694.868530 137.696533,690.651001 
	C128.706924,689.179443 119.466118,688.193542 110.393333,688.510742 
	C94.517860,689.065735 81.899681,696.915588 71.751427,708.837585 
	C68.742836,712.372009 66.078163,716.199158 63.008778,720.215576 
	C56.783253,717.111206 53.112343,711.671692 49.924049,705.805054 
	C27.820452,665.133240 42.428898,623.875671 64.181389,601.670837 
	C85.724953,579.679260 111.748886,571.032837 142.156158,579.032776 
	C161.228165,584.050537 178.654785,592.954102 194.347748,604.682983 
	C219.691895,623.625061 244.648300,643.099670 269.426147,662.780273 
	C283.109619,673.648743 297.582275,682.996521 313.849609,689.329712 
	C344.565704,701.288025 377.653412,690.357178 396.753448,663.393555 
	C418.153870,633.182434 411.337708,589.708496 386.855743,564.543640 
	C368.271423,545.440918 345.144348,534.242493 320.072449,527.056763 
	C264.366913,511.091217 208.365738,496.147858 152.764969,479.833862 
	C141.705872,476.588959 131.250839,470.017761 121.627670,463.372437 
	C85.662971,438.536804 67.051277,403.232697 61.948910,360.374084 
	C58.807137,333.983978 59.743675,307.785492 67.463516,282.167603 
	C78.232399,246.431656 100.131157,218.878357 130.444824,197.670837 
	C163.468582,174.567322 200.485062,164.741211 240.451416,163.589523 
	C274.625916,162.604721 307.634399,169.811890 340.927490,175.600632 
	C360.251282,178.960495 379.734589,182.844177 399.226562,183.342148 
	C414.967316,183.744308 430.833801,179.467926 446.632751,177.185730 
	C450.916351,176.566956 455.157379,175.653397 459.841888,174.792862 
z"/>
<path fill="#09579A" opacity="1.000000" stroke="none" 
	d="
M279.508484,524.879028 
	C279.894714,538.983337 280.044128,552.976746 279.928558,566.967957 
	C279.863617,574.827209 274.465729,579.994080 266.663208,580.025574 
	C253.835724,580.077332 240.993454,579.668640 228.184814,580.163391 
	C218.308716,580.544861 213.165314,574.494507 213.108704,565.620361 
	C212.985413,546.298767 213.150894,526.975281 213.311768,507.161346 
	C235.337051,512.702454 257.248932,518.734802 279.508484,524.879028 
z"/>
<path fill="#095799" opacity="1.000000" stroke="none" 
	d="
M316.526611,680.889893 
	C316.125793,673.255371 315.855621,665.781677 316.036743,658.318970 
	C316.197205,651.710510 320.884827,647.110901 327.564941,647.036865 
	C341.845947,646.878418 356.130829,646.895569 370.412262,647.034241 
	C376.275055,647.091125 381.411499,652.465027 381.920288,658.709595 
	C382.121918,661.184448 381.963989,663.688660 381.952789,666.648071 
	C365.581757,683.126465 346.400269,689.155518 323.943970,683.462463 
	C321.532135,682.850952 319.214752,681.866882 316.526611,680.889893 
z"/>
<path fill="#09579A" opacity="1.000000" stroke="none" 
	d="
M380.894073,571.401917 
	C378.646881,577.546448 374.450439,580.262756 367.888794,580.122437 
	C355.092010,579.848755 342.285156,580.073792 329.482697,580.030762 
	C320.423340,580.000305 316.006958,575.596863 315.961365,566.592896 
	C315.918427,558.113464 315.876221,549.632446 316.015961,541.155029 
	C316.043518,539.481506 316.900757,537.821655 317.746704,535.969116 
	C341.631165,542.884155 363.494080,552.906494 380.894073,571.401917 
z"/>
<path fill="#145896" opacity="1.000000" stroke="none" 
	d="
M265.207428,647.418701 
	C273.741638,646.663696 278.143616,650.040222 279.742645,658.866577 
	C274.912506,655.400391 270.145447,651.544739 265.207428,647.418701 
z"/>
<path fill="#485D86" opacity="1.000000" stroke="none" 
	d="
M303.939209,282.587280 
	C303.603058,275.045776 303.293671,267.030548 303.015381,258.559052 
	C303.352966,266.106384 303.659485,274.109924 303.939209,282.587280 
z"/>
<path fill="#3B67A4" opacity="1.000000" stroke="none" 
	d="
M421.757263,289.911682 
	C421.794769,290.061523 421.608398,290.373566 421.198761,290.842773 
	C421.161438,290.691254 421.347412,290.382568 421.757263,289.911682 
z"/>
<path fill="#FEF101" opacity="1.000000" stroke="none" 
	d="
M729.660034,446.594177 
	C716.950073,452.112976 708.799011,461.561920 706.326233,474.507660 
	C703.621887,488.665649 701.534424,503.145081 701.261292,517.523987 
	C700.565063,554.177185 701.096313,590.852478 700.993408,627.518555 
	C700.956909,640.505737 700.382263,653.490784 700.278687,666.478516 
	C700.162598,681.035217 702.545532,694.985107 710.714294,707.507446 
	C713.124634,711.202454 714.916992,715.300598 717.113037,719.441040 
	C661.262573,719.441040 606.047119,719.441040 549.942627,719.441040 
	C550.875610,717.282593 551.398865,715.971924 551.999573,714.697693 
	C561.049316,695.500244 568.445557,675.730652 572.381775,654.805725 
	C573.147522,650.734863 573.578064,646.542480 573.610229,642.401855 
	C573.801636,617.740479 573.878906,593.077942 573.905396,568.415649 
	C573.986450,492.917938 574.031616,417.420135 574.080872,341.922394 
	C574.099365,313.594879 574.396057,285.263184 574.006042,256.941101 
	C573.633179,229.864578 566.720520,204.268723 554.648499,180.052979 
	C554.208069,179.169586 553.828308,178.256042 553.157654,176.777863 
	C689.202576,176.777863 824.850281,176.777863 960.859985,176.777863 
	C964.301208,221.611603 967.743469,266.458923 971.185669,311.306244 
	C970.899292,311.421600 970.612915,311.536957 970.326538,311.652283 
	C966.574402,306.880859 962.897034,302.048309 959.058289,297.347595 
	C926.730286,257.761078 885.477173,233.118790 835.402222,222.796555 
	C792.441589,213.940826 749.071716,213.563980 705.535767,215.168060 
	C702.094055,215.294861 700.944458,216.534851 700.921021,219.929321 
	C700.795410,238.086823 700.326660,256.242676 700.278809,274.399872 
	C700.172424,314.732574 700.178162,355.065979 700.297791,395.398590 
	C700.324341,404.343872 701.011292,413.287170 701.464478,423.873962 
	C705.054138,420.020660 707.545410,417.295868 710.090515,414.622314 
	C731.381714,392.256958 756.165283,376.197601 787.657776,373.125031 
	C810.241455,370.921661 832.527161,373.920898 854.668640,378.397369 
	C868.866455,381.267792 883.080688,384.212799 897.414246,386.219604 
	C918.971680,389.237793 939.983276,387.347931 959.421631,376.368439 
	C961.389893,375.256744 963.247192,373.948761 965.156006,372.731842 
	C965.707764,373.004089 966.259521,373.276337 966.811279,373.548584 
	C964.601440,380.371399 963.247009,387.627960 960.042969,393.946625 
	C939.408752,434.639923 905.800903,454.194397 860.385437,454.288971 
	C838.407227,454.334747 816.978088,450.504700 795.545410,446.291962 
	C780.498413,443.334412 765.341553,440.478149 749.923523,442.105499 
	C743.207397,442.814362 736.642212,444.953247 729.660034,446.594177 
z"/>
<path fill="#0E5A9C" opacity="1.000000" stroke="none" 
	d="
M405.853882,941.981445 
	C397.909668,925.449585 397.684357,908.617371 401.843079,891.536438 
	C403.047699,886.588867 405.999878,882.587036 411.616211,882.210815 
	C417.084229,881.844482 420.659546,885.151306 423.027954,889.682190 
	C428.210999,899.597595 428.778717,910.434692 428.487640,921.266846 
	C428.332672,927.031189 427.349670,932.827271 426.181183,938.493713 
	C425.214874,943.179932 422.998962,947.338806 417.582550,948.398865 
	C412.113892,949.469116 408.860382,946.284912 405.853882,941.981445 
z"/>
<path fill="#0D5A9C" opacity="1.000000" stroke="none" 
	d="
M512.685730,930.403564 
	C511.439301,934.976318 510.835602,939.393250 508.949554,943.169800 
	C505.657471,949.761780 498.069885,950.810242 493.314728,945.196533 
	C490.405426,941.761963 488.096558,937.408691 486.814545,933.083679 
	C483.167389,920.779785 483.197876,908.157166 485.286591,895.546692 
	C485.608856,893.600830 486.287445,891.675781 487.056335,889.848511 
	C490.946777,880.602356 500.128510,879.361877 506.190887,887.415222 
	C511.302338,894.205383 512.451477,902.382507 512.902527,910.539124 
	C513.259277,916.990051 512.830872,923.484375 512.685730,930.403564 
z"/>
<path fill="#3A67A5" opacity="1.000000" stroke="none" 
	d="
M495.008057,298.000000 
	C495.010437,284.017731 494.982574,270.535309 495.033142,257.053223 
	C495.048767,252.890915 496.129822,249.368698 501.180756,248.971237 
	C506.469879,248.555023 508.957550,251.119598 508.986267,257.382294 
	C509.055756,272.528748 509.012177,287.675720 509.014343,302.822479 
	C509.014801,306.151428 509.193848,309.492432 508.969910,312.806213 
	C508.709991,316.652435 510.104279,318.139923 514.090698,318.063965 
	C524.739380,317.861053 535.395386,317.930969 546.047119,318.032745 
	C551.637573,318.086121 554.489258,321.071686 553.898682,325.944458 
	C553.420898,329.886444 550.990356,331.905914 547.159851,331.926849 
	C532.180176,332.008789 517.199158,332.049011 502.220154,331.923370 
	C497.708130,331.885529 495.137665,328.748657 495.055481,323.466583 
	C494.926025,315.146179 495.012817,306.822357 495.008057,298.000000 
z"/>
    </svg>
     

      
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} to="/dashboard" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
